import axios from "axios"
import { constants } from "@/config/constants"

const init = (context, data) => {
  data.forEach((item, index) => {
    context.commit("UPDATE", { key: item.key, value: item.value })
  })
}

const update = (context, data) => {
  context.commit("UPDATE", data)
}

const updatedb = (context, data) => {
  let user = localStorage.getItem("__crrntUser")

  if (user) {
    user = JSON.parse(user)

    let arr = []
    arr.push({ key: data.key, value: data.value })

    axios
      .post(constants.API_URL + "setting", {
        user_id: user.id,
        data: JSON.stringify(arr)
      })
      .then((res) => {
        context.commit("UPDATE", data)
      })
      .catch((err) => console.log(err))
  }
}

const reset = (context, vm) => {
  vm.$updateSetting("locale", "")
  vm.$updateSetting("rows_per_page", "")
}

export default {
  init,
  update,
  updatedb,
  reset
}
